import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Status } from 'src/app/_models/status';
import { MessService } from 'src/app/_services/mess-service.service';
import { StatusService } from 'src/app/_services/status.service';

@Component({
  selector: 'app-status-edit',
  templateUrl: './status-edit.component.html',
})
export class StatusEditComponent implements OnInit, OnDestroy {
  updateStatusForm: FormGroup;

  statusForUpdate: Status;

  subscriptions: Subscription[] = [];

  constructor(
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute,
    private statusService: StatusService,
    private fb: FormBuilder
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.updateStatusForm = this.fb.group({
      label: ['', Validators.required],
      name: ['', Validators.required],
    });

    this.subscriptions.push(
      this.statusService.updateStatusData.subscribe((responseData: Status) => {
        if (!responseData) {
          this.router.navigate(['./../'], { relativeTo: this.route });
          return;
        }
        this.statusForUpdate = responseData;
        this.patchFormForUpdate();
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Update status === //
  onUpdateStatus() {
    const status = this.updateStatusForm.getRawValue();
    this.statusService.updateStatus(this.statusForUpdate.id, status).subscribe(
      () => {
        this.messService.add({
          severity: 'success',
          title: 'Uspešno ažuriranje',
          detail: 'Ažurirali ste status.',
        });
        this.router.navigate(['./../'], { relativeTo: this.route });
      },
      (error) => {
        const errorObj = error.error.errors;
        const form = this.updateStatusForm;
        const messService = this.messService;
        Object.keys(errorObj).forEach(function (key) {
          const formControl = form.get(key);
          if (formControl) {
            // If error exist set red border to field
            formControl.setErrors({});
          }
          // Push toast error for every field
          messService.addError({
            severity: 'error',
            title: 'Greška',
            detail: errorObj[key],
            sticky: true,
          });
        });
      }
    );
  }

  // * Helpers === //
  patchFormForUpdate() {
    this.updateStatusForm.patchValue({
      label: this.statusForUpdate.label,
      name: this.statusForUpdate.name,
    });
  }
}
